export const DEFAULT_TENANT_USER_ID = 'fdaf4e0f-df71-49ce-bcc9-e21e7c3dec11';